import _classCallCheck from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
/* eslint-disable prefer-rest-params */
/**
 *  Shapes
 *
 *   @copyright 2017, Kevin Lindsey
 *   @module Shapes
 *   @deprecated use ShapeInfo
 */

import ShapeInfo from "./ShapeInfo.js";

/**
 * Build shapes for intersection
 */
var Shapes = /*#__PURE__*/function () {
  function Shapes() {
    _classCallCheck(this, Shapes);
  }
  _createClass(Shapes, null, [{
    key: "arc",
    /**
     *  arc
     *
     *  @deprecated use ShapeInfo.arc
     *  @param {number} centerX
     *  @param {number} centerY
     *  @param {number} radiusX
     *  @param {number} radiusY
     *  @param {number} startRadians
     *  @param {number} endRadians
     *  @returns {module:kld-intersections.ShapeInfo}
     */
    value: function arc(centerX, centerY, radiusX, radiusY, startRadians, endRadians) {
      return ShapeInfo.arc.apply(ShapeInfo, arguments);
    }
    /**
     *  quadraticBezier
     *
     *  @deprecated use ShapeInfo.quadraticBezier
     *  @param {number} p1x
     *  @param {number} p1y
     *  @param {number} p2x
     *  @param {number} p2y
     *  @param {number} p3x
     *  @param {number} p3y
     *  @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "quadraticBezier",
    value: function quadraticBezier(p1x, p1y, p2x, p2y, p3x, p3y) {
      return ShapeInfo.quadraticBezier.apply(ShapeInfo, arguments);
    }
    /**
     *  cubicBezier
     *
     *  @deprecated use ShapeInfo.cubicBezier
     *  @param {number} p1x
     *  @param {number} p1y
     *  @param {number} p2x
     *  @param {number} p2y
     *  @param {number} p3x
     *  @param {number} p3y
     *  @param {number} p4x
     *  @param {number} p4y
     *  @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "cubicBezier",
    value: function cubicBezier(p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) {
      return ShapeInfo.cubicBezier.apply(ShapeInfo, arguments);
    }
    /**
     *  circle
     *
     *  @deprecated use ShapeInfo.circle
     *  @param {number} centerX
     *  @param {number} centerY
     *  @param {number} radius
     *  @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "circle",
    value: function circle(centerX, centerY, radius) {
      return ShapeInfo.circle.apply(ShapeInfo, arguments);
    }
    /**
     *  ellipse
     *
     *  @deprecated use ShapeInfo.ellipse
     *  @param {number} centerX
     *  @param {number} centerY
     *  @param {number} radiusX
     *  @param {number} radiusY
     *  @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "ellipse",
    value: function ellipse(centerX, centerY, radiusX, radiusY) {
      return ShapeInfo.ellipse.apply(ShapeInfo, arguments);
    }
    /**
     *  line
     *
     *  @deprecated use ShapeInfo.line
     *  @param {number} p1x
     *  @param {number} p1y
     *  @param {number} p2x
     *  @param {number} p2y
     *  @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "line",
    value: function line(p1x, p1y, p2x, p2y) {
      return ShapeInfo.line.apply(ShapeInfo, arguments);
    }
    /**
     *  path
     *
     *  @deprecated use ShapeInfo.path
     *  @param {string} pathData
     *  @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "path",
    value: function path(pathData) {
      return ShapeInfo.path.apply(ShapeInfo, arguments);
    }
    /**
     *  polygon
     *
     *  @deprecated use ShapeInfo.polygon
     *  @param {Array<number>} coords
     *  @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "polygon",
    value: function polygon(coords) {
      return ShapeInfo.polygon.apply(ShapeInfo, arguments);
    }
    /**
     *  polyline
     *
     *  @deprecated use ShapeInfo.polyline
     *  @param {Array<number>} coords
     *  @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "polyline",
    value: function polyline(coords) {
      return ShapeInfo.polyline.apply(ShapeInfo, arguments);
    }
    /**
     *  rectangle
     *
     *  @deprecated use ShapeInfo.rectangle
     *  @param {number} x
     *  @param {number} y
     *  @param {number} width
     *  @param {number} height
     *  @param {number} [rx]
     *  @param {number} [ry]
     *  @returns {module:kld-intersections.ShapeInfo}
     */
  }, {
    key: "rectangle",
    value: function rectangle(x, y, width, height) {
      var rx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var ry = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
      return ShapeInfo.rectangle.apply(ShapeInfo, arguments);
    }
  }]);
  return Shapes;
}();
export default Shapes;